import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  externalDeviceConfig: {},
  totalPrice:0,
  totalVat:0,
  webshopSettings: {},
  webshopLoading: false,
  webShopCategoryList: [],
  webShopProductList: [],
  webShopProductInfo: [],
  languageData: [],
  defaultLanguage: "",
  deliveryType: "",
  shopType: "",
  widgetUrl: "",
  webShopMenuPosition: "",
  selectedMenuItem: "",
  isProductLoading: false,
  itemCount: {},
  totalProductsCount: 0,
  supplementsInfo: [],
  selectedProduct: {},
  selectedRecommendedProduct: {},
  addToCartProducts: [],
  selectedDeleteItem: {},
  selectedProductTotalPrice: 0,
  guestDetails: null,
  orderNumberDetails: {},
  openCart: false,
  viewCartCount: 0,
  addToCartOpen: false,
  paymentMethodOpen: false,
  checkoutDetails: null,
  totalPrices: 0,
  webshopOpeningHours: {},
  webshopTimeSlots: [],
  webshopFileds: [],
  guestData: [],
  additionalFields: [],
  reletedProductsInfo: [],
  singleProductTotalIncludeSupp: {},
  languageWords: {},
  recommendedProductError: "",
  supplementError: {},
  deliverySlots: [],
  TVDineInReceived:[],
  TVDineInProgress:[],
  TVDineInReady:[],
  TVPickUpReceived:[],
  TVPickUpProgress:[],
  TVPickUpReady:[],
  CurrencyData:{},
  openSnackBar:false,
  nextProduct:false,
  langID:1,
  relatedwebshopProductInfo:{},
  // Golf 1C (10-10-2026): de webshop-opties van deze widget (lib/webshopOpties), de bewerkmodus en de opmerkingen.
  webshopOpties: null,
  bewerkmodus: { actief: false, naam: "" },
  orderOpmerking: "",
  productOpmerkingen: {},
  gekozenMoment: "",
  // Bezorgplanning (13-10-2026): { planning, postcode, datum, gebied, minimaalBestelbedrag, bezorgkosten } of null.
  bezorgkeuze: null,
  // Bezorgmethode Verzenden (13-10-2026): deliveryType blijft "delivery"; verzenden zegt dat het een pakket is. verzendland: ISO-code.
  verzenden: false,
  verzendland: "NL",
};
export const WebshopSlice = createSlice({
  name: "Webshop",
  initialState,
  reducers: {
    setRelatedWebshopProductInfo:(state, action) => {
      state.relatedwebshopProductInfo = action.payload;
    },
    setWebshopCategoryData: (state, action) => {
      state.webShopCategoryList = action.payload;
    },
    setLanguageData: (state, action) => {
      state.languageData = action.payload;
    },
    updateDefaultLanguage: (state, action) => {
      state.defaultLanguage = action.payload;
    },
    updateDeliveryType: (state, action) => {
      state.deliveryType = action.payload;
    },
    updateShopType: (state, action) => {
      state.shopType = action.payload;
    },
    updateWidgetUrl: (state, action) => {
      state.widgetUrl = action.payload;
    },
    updateWebShopMenuPosition: (state, action) => {
      state.webShopMenuPosition = action.payload;
    },
    updateSelectedMenuItem: (state, action) => {
      state.selectedMenuItem = action.payload;
    },
    setWebshopProductData: (state, action) => {
      state.webShopProductList = action.payload;
    },
    setIsProductLoading: (state, action) => {
      state.isProductLoading = action.payload;
    },
    setWebshopProductInfo: (state, action) => {
      state.webShopProductInfo = action.payload;
    },
    setWebshopRelatedProductsInfo: (state, action) => {
      state.reletedProductsInfo = action.payload;
    },
    setItemCount: (state, action) => {
      // Merge instead of replace so that counts set in one page/component
      // are not wiped when another component (e.g. MenuListCardsComponent)
      // dispatches its local itemCounts for the products it renders.
      state.itemCount = { ...state.itemCount, ...action.payload };
    },
    setSupplementInfo: (state, action) => { 
      state.supplementsInfo = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action?.payload;
    },
    setWebshopSettings: (state, action) => {
      state.webshopSettings = action.payload;
    },
    setWebshopLoading: (state, action) => {
      state.webshopLoading = action.payload;
    },
    setTotalProductCount: (state, action) => {
      state.totalProductsCount = action.payload;
    },
    UpdateAddToCartProducts: (state, action) => {
      state.addToCartProducts = [...state.addToCartProducts, action.payload];
    },
    deleteAddToCartProducts: (state, action) => {
      state.addToCartProducts = state.addToCartProducts.filter(
        (product) => product.idproduct !== action.payload
      );
      // Correctly update itemCount by setting the specific item count to 1
      state.itemCount = {
        ...state.itemCount,
        [action.payload]: 1, // Use correct object property assignment
      };
    },
    removeAddToCartProducts: (state, action) => {
      state.addToCartProducts = [];
    },
    // Add more reducer functions as needed...
    setSelectedDeleteItem: (state, action) => {
      state.selectedDeleteItem = action.payload;
    },
    updateSelectedProductTotalPrice: (state, action) => {
      state.selectedProductTotalPrice = action.payload;
    },
    updateGuestDetails: (state, action) => {
      state.guestDetails = action.payload;
    },
    updateOrderNumberDetails: (state, action) => {
      state.orderNumberDetails = action.payload;
    },
    setOpenCart: (state, action) => {
      state.openCart = action.payload;
    },
    setViewCartCount: (state, action) => {
      state.viewCartCount = action.payload;
    },
    resetKiosk: (state) => {
      // state.selectedMenuItem =initialState.selectedMenuItem
      state.addToCartProducts = initialState.addToCartProducts;
      state.selectedProduct = initialState.selectedProduct;
      state.itemCount = initialState.itemCount;
      state.totalProductsCount = initialState.totalProductsCount;
      state.addToCartOpen = initialState.addToCartOpen;
      state.paymentMethodOpen = initialState.paymentMethodOpen;
      state.openCart = initialState.openCart;
      // state.webShopCategoryList = initialState.webShopCategoryList;
      // state.webShopProductList = initialState.webShopProductList;
      // state.webShopProductInfo = initialState.webShopProductInfo;
      // state.languageData = initialState.languageData;
      // state.defaultLanguage = initialState.defaultLanguage;
      // state.deliveryType = initialState.deliveryType;
    },
    resetWebshop: (state) => {
    //  state.selectedMenuItem =initialState.selectedMenuItem
      state.addToCartProducts = initialState.addToCartProducts;
      state.selectedProduct = initialState.selectedProduct;
      state.itemCount = initialState.itemCount;
      state.totalProductsCount = initialState.totalProductsCount;
      state.addToCartOpen = initialState.addToCartOpen;
      state.paymentMethodOpen = initialState.paymentMethodOpen;
      state.openCart = initialState.openCart;
      state.supplementsInfo=initialState.supplementsInfo
      state.orderOpmerking = initialState.orderOpmerking;
      state.productOpmerkingen = initialState.productOpmerkingen;
    },

    setAddToCartOpen: (state, action) => {
      state.addToCartOpen = action.payload;
    },
    setPaymentMethodOpen: (state, action) => {
      state.paymentMethodOpen = action.payload;
    },
    updateCheckoutDetails: (state, action) => {
      state.checkoutDetails = action.payload;
    },
    updateTotalPrice: (state, action) => {
      state.totalPrices = action.payload;
    },
    updateWebshopOpeningHours: (state, action) => {
      state.webshopOpeningHours = action.payload;
    },
    updateWebshopTimeSlots: (state, action) => {
      state.webshopTimeSlots = action.payload;
    },
    setWebshopFileds: (state, action) => {
      state.webshopFileds = action.payload;
    },
    setGuestData: (state, action) => {
      state.guestData = action.payload;
    },
    setAdditionalFields: (state, action) => {
      state.additionalFields = action.payload;
    },
    setSingleProductTotalIncludeSupp: (state, action) => {
      state.singleProductTotalIncludeSupp = action.payload;
    },
    setLanguageWords: (state, action) => {
      state.languageWords = action.payload;
    },
    setRecommendedProductError: (state, action) => {
      state.recommendedProductError = action.payload;
    },
    setSupplementError: (state, action) => {
      state.supplementError = action.payload;
    },
    setSelectedRecommendedProduct: (state, action) => {
      state.selectedRecommendedProduct = action.payload;
    },
    updateDeliverySlots:(state,action)=>{
      state.deliverySlots=action.payload
    },
    updateTVDineInReceived:(state,action)=>{
      state.TVDineInReceived = action.payload
    },
    updateTVDineInProgress:(state,action)=>{
      state.TVDineInProgress = action.payload
    },
    updateTVDineInReady:(state,action)=>{
      state.TVDineInReady = action.payload
    },
    updatePickupReceived:(state,action)=>{
      state.TVPickUpReceived = action.payload
    },
    updatePickupProgress:(state,action)=>{
      state.TVPickUpProgress = action.payload
    },
    updatePickupReady:(state,action)=>{
      state.TVPickUpReady = action.payload
    },
    setTotalPrice:(state,action)=>{
      state.totalPrice=action.payload

    },
    setTotalVat:(state,action)=>{
      state.totalVat=action.payload

    },
    updateCurrencyData:(state,action)=>{
      state.CurrencyData=action.payload
    },
    setOpenSnackBar:(state,action)=>{
      state.openSnackBar=action.payload
    },
    setNextProduct:(state,action)=>{
      state.nextProduct=action.payload
    },
    updateLangId:(state,action)=>{
      state.langID=action.payload
    },
    setWebshopOpties: (state, action) => {
      state.webshopOpties = action.payload;
    },
    setBewerkmodus: (state, action) => {
      state.bewerkmodus = action.payload;
    },
    setGekozenMoment: (state, action) => {
      state.gekozenMoment = action.payload || "";
    },
    setBezorgkeuze: (state, action) => {
      state.bezorgkeuze = action.payload || null;
    },
    setVerzenden: (state, action) => {
      state.verzenden = !!action.payload;
    },
    setVerzendland: (state, action) => {
      state.verzendland = action.payload || "NL";
    },
    setOrderOpmerking: (state, action) => {
      state.orderOpmerking = action.payload;
    },
    setProductOpmerking: (state, action) => {
      const { idproduct, tekst } = action.payload || {};
      state.productOpmerkingen = { ...state.productOpmerkingen, [idproduct]: tekst };
    },
    setExternalDeviceConfig:(state,action)=>{
      state.externalDeviceConfig=action.payload
    }
    // Add more action creators as needed...
  },
});

// Action creators are generated for each case reducer function
export const {
  setExternalDeviceConfig,
  setTotalPrice,
  setTotalVat,
  setWebshopCategoryData,
  setLanguageData,
  updateDefaultLanguage,
  updateDeliveryType,
  updateShopType,
  updateWidgetUrl,
  updateWebShopMenuPosition,
  updateSelectedMenuItem,
  setWebshopProductData,
  setIsProductLoading,
  setWebshopProductInfo,
  setItemCount,
  setSupplementInfo,
  setSelectedProduct,
  setWebshopSettings,
  setWebshopLoading,
  setTotalProductCount,
  UpdateAddToCartProducts,
  removeAddToCartProducts,
  deleteAddToCartProducts,
  setSelectedDeleteItem,
  updateSelectedProductTotalPrice,
  updateGuestDetails,
  updateOrderNumberDetails,
  setOpenCart,
  setViewCartCount,
  setAddToCartOpen,
  resetKiosk,
  setPaymentMethodOpen,
  updateCheckoutDetails,
  updateTotalPrice,
  updateWebshopOpeningHours,
  updateWebshopTimeSlots,
  setWebshopFileds,
  setGuestData,
  setAdditionalFields,
  setWebshopRelatedProductsInfo,
  setSingleProductTotalIncludeSupp,
  setLanguageWords,
  setRecommendedProductError,
  setSupplementError,
  setSelectedRecommendedProduct,
  updateDeliverySlots,
  updateTVDineInReceived,
  updateTVDineInProgress,
  updateTVDineInReady,
  updatePickupReceived,
  updatePickupProgress,
  updatePickupReady,
  resetWebshop,
  updateCurrencyData,
  setOpenSnackBar,
  setNextProduct,
  updateLangId,
  setRelatedWebshopProductInfo,
  setWebshopOpties,
  setBewerkmodus,
  setOrderOpmerking,
  setGekozenMoment,
  setBezorgkeuze,
  setVerzenden,
  setVerzendland,
  setProductOpmerking,

  

  // Add more action creators as needed...
} = WebshopSlice.actions;

export default WebshopSlice.reducer;
